export const AMPLITUDE_SEARCH_INITIATED = 'Search Initiated'
export const AMPLITUDE_ORDER_CANCELLED = 'Order Cancelled'
export const AMPLITUDE_PRODUCT_ERROR = 'Product Page Error'
export const AMPLITUDE_COMPLETE_ORDER = 'Complete Order Clicked'
export const AMPLITUDE_ORDER_COMPLETED = 'Order Completed'
export const AMPLITUDE_WITHOUT_STOCK = 'Without Stock Error'
export const AMPLITUDE_UNAVAILABLE_GIFT_CARD_ERROR =
  'Unavailable Gift Card Error'
export const AMPLITUDE_CANNOT_BE_DELIVERED = 'Cannot Be Delivered Error'
export const AMPLITUDE_WITHOUT_PRICE = 'Without Price Error'
export const AMPLITUDE_GENERIC_ERROR = 'Generic Error'
export const AMPLITUDE_COUPON_NOT_FOUND = 'Coupon Not Found/Expired Error'
export const AMPLITUDE_CLICKED = 'Clicked'
export const AMPLITUDE_PRODUCT_QUICK_ADDED = 'Product Quick Added to Cart'
export const AMPLITUDE_PRODUCT_PAGE_OPENED = 'Product Page Opened'
export const AMPLITUDE_PRODUCT_ADDED = 'Product Added to Cart'
export const AMPLITUDE_LOCATION_BAR_INSERTED = 'Location Bar Inserted'
export const AMPLITUDE_SHIPPING_METHOD_SELECTED = 'Shipping Method Selected'
export const AMPLITUDE_PAYMENT_METHOD_SELECTED = 'Payment Method Selected'
export const AMPLITUDE_RECEIPT_REPRINTED = 'Receipt Reprinted'
export const AMPLITUDE_CLIENT_IDENTIFIED = 'Client Identified'
export const AMPLITUDE_ANONYMIZED = 'Client Anonymized'
export const AMPLITUDE_AVAILABILITY_BOX_EXPANDED = 'Availability Box Expanded'
export const AMPLITUDE_PRODUCT_REMOVED_FROM_CART = 'Product Removed from Cart'
export const AMPLITUDE_PRODUCT_PRICE_CHANGED = 'Product Price Changed'
export const AMPLITUDE_PRODUCT_SLA_CHANGED = 'Product SLA Changed'
export const AMPLITUDE_CLIENT_PROFILE_CREATED = 'Client Profile Created'
export const AMPLITUDE_CLIENT_PROFILE_EDITED = 'Client Profile Edited'
export const AMPLITUDE_BACK_BUTTON = 'Back Button'

export enum AmplitudeSidebarLabels {
  ConfigureDevice = 'Configure Device',
  Fulfillment = 'Fulfillment',
  NewFulfillment = 'New Fulfillment',
  StorePerformance = 'Store Performance',
  NewOrder = 'New Order',
  CartCapture = 'Cart Capture',
  CurrentOrders = 'Current Orders',
  LastOrders = 'Last Orders',
  ReturnExchange = 'Return and Exchange',
  ResetLocalData = 'Reset app local data',
  ChangeVendor = 'Change Vendor',
  Home = 'Home',
  ChangePaymentHardware = 'Change Payment Hardware',
  ClearCache = 'Clear Cache',
  UseAlphaEnv = 'Use Alpha Environment',
  UseBetaEnv = 'Use Beta Environment',
  UseStableEnv = 'Use Stable Environment',
  UseDevEnv = 'Use Develpment Environment',
  RedefineSettings = 'Redefine Settings',
  EnableCatalogCache = 'Enable Catalog Cache',
  DisableCatalogCache = 'Disable Catalog Cache',
  Logout = 'Logout',
  CustomLink = 'Custom Link',
  ReportError = 'Report Error',
  DownloadApp = 'Download App',
  Observation = 'Observation',
  Coupon = 'Coupon',
  IDOnInvoice = 'ID on Invoice',
  Giftcard = 'Giftcard',
}
